
import { writeLog } from '~/utils/log'

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();

  nuxtApp.vueApp.config.errorHandler = (error: any, instance, info) => {
    const route = useRoute();

    //if( runtimeConfig.NUXT_DEBUG ) {
      writeLog({
        url: route.fullPath,
        message: error.message || 'No error message',
        stack: error.stack || 'No stack trace'
      }, 'global-error');
    //}



    console.error('SK Headless Error:', error)
  }

  nuxtApp.hook('vue:error', (error: any) => {
    const route = useRoute();

    //if( runtimeConfig.NUXT_DEBUG ) {
      writeLog({
        url: route.fullPath,
        message: error.message || 'No error message',
        stack: error.stack || 'No stack trace'
      }, 'vue-error');
    //}

    console.error('Vue Error Handler:', error)
  })

  nuxtApp.hook('app:error', (error: any) => {
    const route = useRoute();

    //if( runtimeConfig.NUXT_DEBUG ) {
      writeLog({
        url: route.fullPath,
        message: error.message || 'No error message',
        stack: error.stack || 'No stack trace'
      }, 'app-error');
    //}

    console.error('Nuxt App Error:', error)
  })
})